import { apiClient } from './baseApi';

export const aiSettingsService = {
  async get() {
    const response = await apiClient.get('/ai-settings');
    return response.data?.data ?? null;
  },

  async save({ apiKey, model }) {
    const response = await apiClient.put('/ai-settings', { apiKey, model });
    return response.data?.data;
  },
};
